// extracted by mini-css-extract-plugin
export default {"title":"PrivilegeBlock_title__QSVXs","item":"PrivilegeBlock_item__qiHGi","subtitle":"PrivilegeBlock_subtitle__ivv-L","paragraph":"PrivilegeBlock_paragraph__AysDa"};